import React from 'react';
import Drawer from '@mui/material/Drawer';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import './index.scss';

interface SideDrawerProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  width?: number | string;
  anchor?: 'left' | 'right' | 'top' | 'bottom';
}

const SideDrawer: React.FC<SideDrawerProps> = ({
  open,
  onClose,
  title,
  children,
  width = 600,
  anchor = 'right',
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: width },
      }}
    >
      <div className="d-flex flex-column h-100">
        <div className="p-4 border-bottom d-flex justify-content-between align-items-center">
          <h5 className="mb-0">{title}</h5>
          <button
            type="button"
            className="btn-close text-reset"
            aria-label="Close"
            onClick={onClose}
          ></button>
        </div>
        <div className="p-4 flex-grow-1 overflow-auto">{children}</div>
      </div>
    </Drawer>
  );
};

export default SideDrawer;
